<template>
  <v-container fluid grid-list-sm>
    <v-card v-if="!reinsuranceSection">
      <v-toolbar :dense="true" v-if="!reinsuranceSection">
        <v-toolbar-title> <v-icon>mdi-content-duplicate</v-icon> Reinsurance </v-toolbar-title>
        <v-spacer></v-spacer>
        <span class="body-2 mr-2">Claim No: {{ this.commonInfo.clmNo }}</span>
        <v-menu offset-x :nudge-left="370" :close-on-content-click="false" :min-width="300" :max-height="400">
          <template v-slot:activator="{ on }">
            <v-btn color="secondary" class="white--text" v-on="on">
              <span>Columns</span>
              <v-icon right dark>mdi-table-column-plus-after</v-icon>
            </v-btn>
          </template>
          <v-card>
            <v-card-text>
              <template v-if="columns.length > 0">
                <v-checkbox
                  v-for="column in columns"
                  :key="column.value"
                  :label="column.text"
                  :value="column.value"
                  v-model="selectedColumns"
                ></v-checkbox>
              </template>
              <template v-else>No column found</template>
            </v-card-text>
          </v-card>
        </v-menu>
      </v-toolbar>
      <v-flex xs12>
        <v-card :flat="true">
          <form>
            <v-expansion-panels v-model="panel" multiple>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  <div><v-icon>mdi-filter-variant</v-icon>Filters</div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-card-text>
                    <v-layout row wrap>
                      <v-flex lg3 xs6>
                        <v-autocomplete
                          clearable
                          v-model="filters.riType"
                          :items="riTypeList"
                          :label="filtersLabel.riType"
                          item-text="label"
                          item-value="value"
                          data-vv-name="riType"
                          :data-vv-as="filtersLabel.riType"
                          :error-messages="errors.collect('riType')"
                          v-validate="'entry'"
                        ></v-autocomplete>
                      </v-flex>
                      <v-flex lg3 xs6>
                        <v-text-field
                          v-model="filters.riCo"
                          :label="filtersLabel.riCo"
                          :error-messages="errors.collect('riCo')"
                          data-vv-name="riCo"
                          :data-vv-as="filtersLabel.riCo"
                          v-validate="'entry|max:60'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg3 xs6>
                        <v-text-field
                          v-model="filters.acctNoSfx"
                          :label="filtersLabel.acctNoSfx"
                          :error-messages="errors.collect('acctNoSfx')"
                          data-vv-name="acctNoSfx"
                          :data-vv-as="filtersLabel.acctNoSfx"
                          v-validate="'entry|max:60'"
                        ></v-text-field>
                      </v-flex>
                      <v-flex lg3 xs6>
                        <v-autocomplete
                          clearable
                          v-model="filters.proplXol"
                          :items="proplXolList"
                          :label="filtersLabel.proplXol"
                          item-text="label"
                          item-value="value"
                          data-vv-name="proplXol"
                          :data-vv-as="filtersLabel.proplXol"
                          :error-messages="errors.collect('proplXol')"
                          v-validate="'entry'"
                        ></v-autocomplete>
                      </v-flex>
                    </v-layout>
                    <transition name="slide-x-transition" mode="out-in">
                      <v-layout row wrap v-if="showDetailFilters">
                        <v-flex lg3 xs6>
                          <v-text-field
                            v-model="filters.riSipct"
                            type="tel"
                            :label="filtersLabel.riSipct"
                            :error-messages="errors.collect('riSipct')"
                            data-vv-name="riSipct"
                            :data-vv-as="filtersLabel.riSipct"
                            v-validate="'decimal:6|numeric|max_value:100'"
                          ></v-text-field>
                        </v-flex>
                        <v-flex lg3 xs6>
                          <v-text-field
                            v-model="filters.riLim"
                            type="tel"
                            :label="filtersLabel.riLim"
                            :error-messages="errors.collect('riLim')"
                            data-vv-name="riLim"
                            :data-vv-as="filtersLabel.riSi"
                            v-validate="'decimal:6'"
                          ></v-text-field>
                        </v-flex>
                      </v-layout>
                    </transition>
                  </v-card-text>
                  <v-card-actions>
                    <v-btn text @click.native="showDetailFilters = true" v-if="!showDetailFilters">Show More Filters</v-btn>
                    <v-btn text @click.native="showDetailFilters = false" v-if="showDetailFilters">Show Less Filters</v-btn>
                    <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                  </v-card-actions>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </form>
        </v-card>
      </v-flex>
      <v-expand-transition>
        <v-data-table
          v-bind:headers="listHeaders"
          v-bind:items="items"
          :server-items-length="totalItems"
          :footer-props="{'items-per-page-options': itemsPerPage }"
          v-bind:options.sync="pagination"
          item-key="key"
          :loading="loading"
          :no-data-text="noDataText"
          v-if="!reinsuranceSection"
        >
          <template v-slot:item="row"
            ><tr>
              <td v-for="column in selectedColumns" :key="column">{{ row.item[column] }}</td>
              <td class="table-action-header">
                <table-action
                  :rowData="row"
                  :review="!reinsuranceSection"
                  @review="editReinsurance(row)"
                  query
                  @query="queryReinsurance(row)"
                  :loading="loading"
                ></table-action>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-expand-transition>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="primary" @click.native="addReinsurance">
          <span>Reinsurance</span>
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
        <v-spacer />
        <v-btn color="red darken-1" text @click.native="doClose">Close</v-btn>
      </v-card-actions>
    </v-card>
    <v-card v-if="reinsuranceSection">
      <v-toolbar :dense="true" :flat="true">
        <v-toolbar-title> <v-icon>mdi-content-duplicate</v-icon> Reinsurance Detail </v-toolbar-title>
      </v-toolbar>
      <v-card-text id="reinsuranceCard" style="max-height: 600px; overflow-y: auto">
        <v-layout row wrap>
          <v-flex md4 xs4 v-if="mode === 'create'">
            <v-autocomplete
              v-model="reinsurance.riType"
              :items="riTypeList"
              :label="labels.riType"
              item-text="label"
              item-value="value"
              data-vv-name="riType"
              :data-vv-as="labels.riType"
              :error-messages="errors.collect('riType')"
              v-validate="'required|validRiType|entry'"
              @change="riTypeChanged"
            />
          </v-flex>
          <v-flex md4 xs4 v-else>
            <v-subheader class="queryLabel">{{ labels.riType }}</v-subheader>
            <div class="queryValue">{{ getItemValue(reinsurance.riType, riTypeList).label }}</div>
          </v-flex>
          <v-flex md4 xs4>
            <v-autocomplete
              v-model="reinsurance.proplXol"
              :items="proplXolList"
              :label="labels.proplXol"
              item-text="label"
              item-value="value"
              data-vv-name="proplXol"
              :data-vv-as="labels.proplXol"
              :error-messages="errors.collect('proplXol')"
              v-validate="'required|entry'"
              :readonly="mode === 'query'"
            />
          </v-flex>
          <v-flex md1 xs4 offset-md3>
            <v-subheader class="queryLabel">{{ labels.verCnt }}</v-subheader>
            <div class="queryValue">{{ reinsurance.verCnt }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 xs6 v-if="mode === 'create'">
            <v-text-field
              :disabled="reinsurance.riType === undefined || disableRiCo"
              v-model="reinsurance.riCoDesc"
              :label="labels.riCo"
              :error-messages="errors.collect('riCo')"
              data-vv-name="riCo"
              :data-vv-as="labels.riCo"
              v-validate="'required|entry|max:60'"
              readonly
              @click="doShowRiCo"
            >
              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                <v-icon v-if="reinsurance.riType !== undefined" color="info" @click="doShowRiCo" v-text="'mdi-magnify'"></v-icon>
              </v-slide-x-reverse-transition>
            </v-text-field>
          </v-flex>
          <v-flex md6 xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.riCo }}</v-subheader>
            <div class="queryValue">{{ reinsurance.riCo + ' - ' + reinsurance.riCoDesc }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 xs6 v-if="mode === 'create'">
            <v-text-field
              v-model="reinsurance.acctNoSfx"
              :label="labels.acctNoSfx"
              :error-messages="errors.collect('acctNoSfx')"
              data-vv-name="acctNoSfx"
              :data-vv-as="labels.acctNoSfx"
              v-validate="'required|entry|max:60'"
              :disabled="disableSfx"
            >
              <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                <v-icon
                  v-if="reinsurance.riType === 'F' || reinsurance.riType === 'C'"
                  @click="doShowAcctNoSfx"
                  color="info"
                  v-text="'mdi-magnify'"
                ></v-icon>
              </v-slide-x-reverse-transition>
            </v-text-field>
          </v-flex>
          <v-flex md6 xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.acctNoSfx }}</v-subheader>
            <div class="queryValue" v-if="reinsurance.acctNoSfx">{{ reinsurance.acctNoSfx }}</div>
            <div class="queryValue" v-else>-</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 xs6 v-if="mode === 'create' || mode === 'review'">
            <v-text-field
              append-icon="mdi-percent"
              v-model="reinsurance.riSipct"
              type="text"
              :label="labels.riSipct"
              :error-messages="errors.collect('riSipct')"
              data-vv-name="riSipct"
              :data-vv-as="labels.riSipct"
              v-validate="'required|decimal:6|max_value:100'"
            ></v-text-field>
          </v-flex>
          <v-flex md6 xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.riSipct }}</v-subheader>
            <div class="queryValue">{{ reinsurance.riSipct }}</div>
          </v-flex>
          <v-flex md6 xs6>
            <v-checkbox
              v-model="reinsurance.terminated"
              :label="labels.terminated"
              :error-messages="errors.collect('terminated')"
              data-vv-name="terminated"
              :data-vv-as="labels.terminated"
              :disabled="mode !== 'review'"
              hide-details
            />
          </v-flex>
          <v-flex md6 xs6 v-if="mode === 'create' || mode === 'review'">
            <v-text-field
              v-model="reinsurance.priority"
              v-num-mask="{ negative: false, intScale: 13, decScale: 2 }"
              :label="labels.priority"
              :error-messages="errors.collect('priority')"
              data-vv-name="priority"
              :data-vv-as="labels.priority"
              v-validate="'required'"
            />
          </v-flex>
          <v-flex md6 xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.priority }}</v-subheader>
            <div class="queryValue">{{ reinsurance.priority }}</div>
          </v-flex>
          <v-flex md6 xs6 v-if="mode === 'create' || mode === 'review'">
            <v-text-field
              v-model="reinsurance.riLim"
              v-num-mask="{ negative: false, intScale: 13, decScale: 2 }"
              :label="labels.riLim"
              :error-messages="errors.collect('riLim')"
              data-vv-name="riLim"
              :data-vv-as="labels.riLim"
            />
          </v-flex>
          <v-flex md6 xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.riLim }}</v-subheader>
            <div class="queryValue">{{ reinsurance.riLim }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap> </v-layout>
        <v-layout row wrap>
          <v-flex md6 xs6 v-if="mode === 'create'">
            <v-text-field
              v-model="reinsurance.cesNo"
              type="tel"
              :label="labels.cesNo"
              :error-messages="errors.collect('cesNo')"
              data-vv-name="cesNo"
              :data-vv-as="labels.cesNo"
              v-validate="'required|integer|min_value:1|max_value:999999'"
              :maxlength="6"
            ></v-text-field>
          </v-flex>
          <v-flex md6 xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.cesNo }}</v-subheader>
            <div class="queryValue">{{ reinsurance.cesNo }}</div>
          </v-flex>
          <v-flex md6 xs6>
            <v-autocomplete
              :items="recipList"
              v-model="reinsurance.recip"
              :label="labels.recip"
              item-text="label"
              item-value="value"
              data-vv-name="recip"
              :data-vv-as="labels.recip"
              :error-messages="errors.collect('recip')"
              v-validate="'required'"
              :disabled="mode !== 'create'"
              hide-details
            />
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 xs6 v-if="mode === 'create'">
            <v-text-field
              v-model="reinsurance.cesYr"
              type="tel"
              :label="labels.cesYr"
              :error-messages="errors.collect('cesYr')"
              data-vv-name="cesYr"
              :data-vv-as="labels.cesYr"
              v-validate="'required|integer|min_value:1|max_value:9999'"
            ></v-text-field>
          </v-flex>
          <v-flex md6 xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.cesYr }}</v-subheader>
            <div class="queryValue">{{ reinsurance.cesYr }}</div>
          </v-flex>
          <!--
          <v-flex md4 xs4 v-if="mode!=='query'">
            <cal-picker v-model="reinsurance.plaDate" :label="labels.plaDate" :data-vv-as="labels.plaDate" data-vv-name="plaDate" :error-messages="errors.collect('plaDate')"/>
          </v-flex>
          <v-flex md6 xs6 v-else>
            <v-subheader class="queryLabel">{{labels.plaDate}}</v-subheader>
            <div class="queryValue">{{reinsurance.plaDate}}</div>
          </v-flex>-->
          <v-flex md6 xs6>
            <v-subheader class="queryLabel">{{ labels.plaDate }}</v-subheader>
            <div class="queryValue" v-if="reinsurance.plaDate">{{ formatDisplayDateTime(reinsurance.plaDate) }}</div>
            <div class="queryValue" v-else>-</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <v-flex md6 xs6 v-if="mode !== 'query'">
            <v-text-field
              v-model="reinsurance.theirPolNo"
              :label="labels.theirPolNo"
              :error-messages="errors.collect('theirPolNo')"
              data-vv-name="theirPolNo"
              :data-vv-as="labels.theirPolNo"
              v-validate="'max:30'"
            />
          </v-flex>
          <v-flex md6 xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.theirPolNo }}</v-subheader>
            <div class="queryValue">{{ reinsurance.theirPolNo }}</div>
          </v-flex>
          <v-flex md6 xs6 v-if="mode !== 'query'">
            <v-text-field
              v-model="reinsurance.theirClmNo"
              :label="labels.theirClmNo"
              :error-messages="errors.collect('theirClmNo')"
              data-vv-name="theirClmNo"
              :data-vv-as="labels.theirClmNo"
              v-validate="'max:30'"
            />
          </v-flex>
          <v-flex md6 xs6 v-else>
            <v-subheader class="queryLabel">{{ labels.theirClmNo }}</v-subheader>
            <div class="queryValue">{{ reinsurance.theirClmNo }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap>
          <!--
          <v-flex md6 xs6 v-if="mode !=='query'">
            <v-text-field v-model="reinsurance.lastResAdv" type="tel" :label="labels.lastResAdv" :error-messages="errors.collect('lastResAdv')"
              data-vv-name="lastResAdv" :data-vv-as="labels.lastResAdv" v-validate="'required|decimal:6|max:15'"/>
          </v-flex>
          <v-flex md6 xs6 v-else>
            <v-subheader class="queryLabel">{{labels.lastResAdv}}</v-subheader>
            <div class="queryValue">{{reinsurance.lastResAdv}}</div>
          </v-flex>
          <v-flex md4 xs4 v-if="mode !=='query'">
            <cal-picker v-model="reinsurance.lastResAdvDate" :label="labels.lastResAdvDate" :data-vv-as="labels.lastResAdvDate" data-vv-name="lastResAdvDate" :error-messages="errors.collect('lastResAdvDate')"/>
          </v-flex>
          <v-flex md6 xs6 v-else>
            <v-subheader class="queryLabel">{{labels.lastResAdvDate}}</v-subheader>
            <div class="queryValue">{{formatDisplayDateTime(reinsurance.lastResAdvDate)}}</div>
          </v-flex>-->
          <v-flex md6 xs6>
            <v-subheader class="queryLabel">{{ labels.lastResAdv }}</v-subheader>
            <div class="queryValue">{{ reinsurance.lastResAdv }}</div>
          </v-flex>
          <v-flex md6 xs6>
            <v-subheader class="queryLabel">{{ labels.lastResAdvDate }}</v-subheader>
            <div class="queryValue" v-if="reinsurance.lastResAdvDate">{{ formatDisplayDateTime(reinsurance.lastResAdvDate) }}</div>
            <div class="queryValue" v-else>-</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="reinsurance.createdBy">
          <v-flex md6 xs6>
            <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
            <div class="queryValue">{{ reinsurance.createdBy }}</div>
          </v-flex>
          <v-flex md6 xs6>
            <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDateTime(reinsurance.createdDate) }}</div>
          </v-flex>
        </v-layout>
        <v-layout row wrap v-if="reinsurance.modifiedBy">
          <v-flex md6 xs6>
            <v-subheader class="queryLabel">{{ labels.modifiedBy }}</v-subheader>
            <div class="queryValue">{{ reinsurance.modifiedBy }}</div>
          </v-flex>
          <v-flex md6 xs6>
            <v-subheader class="queryLabel">{{ labels.modifiedDate }}</v-subheader>
            <div class="queryValue">{{ formatDisplayDateTime(reinsurance.modifiedDate) }}</div>
          </v-flex>
        </v-layout>
      </v-card-text>
      <v-card-actions v-if="mode === 'query'">
        <v-spacer />
        <v-btn color="red darken-1" text @click.native="doCancel">Close</v-btn>
      </v-card-actions>
      <v-card-actions v-else>
        <v-spacer />
        <v-btn color="primary" text @click.native="doSave">Save</v-btn>
        <v-btn color="red darken-1" text @click.native="doCancel">Cancel</v-btn>
      </v-card-actions>
    </v-card>
    <v-dialog v-model="riCoDialog" width="1000px" persistent>
      <intermediary-help-list :interGrps="'11,20'" @close="riCoDialog = false" headerInfo="default" @assign-intermediary-data="setRicoInter" />
    </v-dialog>
    <v-dialog v-model="riTreatyDialog" width="1000px">
      <treaty-No-help-list @close="riTreatyDialog = false" :riType=this.reinsurance.riType @assign-treaty-info="setRiCoTreaty"></treaty-No-help-list>
    </v-dialog>
    <v-dialog v-model="riAcctNoSfxDialog" width="1280px">
      <v-card>
        <v-card-title class="secondary lighten-4">
          <span class="headline">Select Acct No Suffix</span>
          <v-spacer></v-spacer>
          <v-btn text icon @click="riAcctNoSfxDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text>
          <v-flex xs12 class="mt-2">
            <v-data-table
              class="elevation-1"
              v-bind:headers="listRIAcctNoSfx"
              v-bind:items="riAcctNoSfxItems"
              :server-items-length="totalItemsRiAcctNoSfx"
              :footer-props="{'items-per-page-options': itemsPerPage }"
              v-bind:options.sync="paginationRiAcctNoSfx"
              item-key="x"
              :loading="loading"
              :no-data-text="noDataText"
            >
              <template v-slot:item="row">
                <tr>
                  <td>{{ row.item.acctNoSfx }}</td>
                  <td>{{ row.item.acctNoSfxDesc }}</td>
                  <td class="table-action-header">
                    <table-action :rowData="row" copy @copy="setRiAcctNoSfx(row.item)"></table-action>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import { listMixin } from '@/mixins/listMixin'
import MessageMixin from '@/mixins/message'
import { expandURI, filterQuery } from '@/utils/ajax'
import { ClaimCommonMixin } from '@/mixins/claim/ClaimCommonMixin'
import { removeFormatNumber, formatDisplayNumber } from '@/utils/number'
import { formatDisplayDateTime } from '@/utils/date'
import { riAjaxMixin } from '@/mixins/reinsurance/riAjaxMixin'
import { riListMixin } from '@/mixins/reinsurance/riListMixin'
import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList'
import TreatyNoHelpList from '@/components/core/claimManagement/helpList/TreatyNoHelpList'
import { CLAIMS_HASRIORRESADJ } from '@/store/types'

export default {
  components: {
    IntermediaryHelpList,
    TreatyNoHelpList
  },
  props: {
    load: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      showDetailFilters: false,
      editMode: false,
      reinsuranceSection: false,
      // panel control
      panel: [],
      riCoDialog: false,
      riTreatyDialog: false,
      riAcctNoSfxDialog: false,
      disableSfx: true,
      disableRiCo: true,
      columns: [
        { text: 'Reinsurance Type', align: 'left', value: 'riTypeDesc' },
        { text: 'CO / RI Company/Treaty', value: 'riCo' },
        { text: 'Suffix', value: 'acctNoSfx' },
        { text: 'Version', value: 'verCnt' },
        { text: 'Proportional / XOL', value: 'proplXolDesc' },
        { text: 'RI Sum Insured %', value: 'riSipct' },
        { text: 'RI Limit', value: 'riLim' },
        { text: 'Priority Limit', value: 'priority' }
      ],
      selectedColumns: ['riTypeDesc', 'riCo', 'acctNoSfx', 'verCnt', 'proplXolDesc', 'riSipct'],
      filters: {
        riType: undefined,
        riCo: undefined,
        acctNoSfx: undefined,
        proplXol: undefined,
        riSipct: undefined,
        riLim: undefined,
        priority: undefined
      },
      filtersLabel: {
        riType: 'Reinsurance Type',
        riCo: 'CO / RI Company/Treaty',
        acctNoSfx: 'Suffix',
        proplXol: 'Proportional / XOL',
        riSipct: 'RI Sum Insured %',
        riLim: 'RI Limit',
        priority: 'Priority Limit'
      },
      labels: {
        riType: 'Reinsurance Type',
        riCo: 'CO / RI Company/Treaty',
        verCnt: 'Version',
        acctNoSfx: 'Suffix',
        proplXol: 'Proportional / XOL',
        riSipct: 'RI Sum Insured %',
        riLim: 'RI Limit',
        priority: 'Priority Limit',
        terminated: 'RI Terminated',
        cesNo: 'Cession No.',
        cesYr: 'Cession Year',
        plaDate: 'PLA Date',
        theirPolNo: 'Their Policy No',
        lastResAdv: 'Last Reserve Advised',
        theirClmNo: 'Their Claim No',
        lastResAdvDate: 'Last Reserve Advice Date',
        createdBy: 'Created By',
        createdDate: 'Created Date',
        modifiedBy: 'Modified By',
        modifiedDate: 'Modified Date',
        recip: 'Reciprocal'
      },
      mode: 'create',
      reinsurance: {
        verCnt: 0,
        riType: undefined,
        riCo: undefined,
        riCoDesc: undefined,
        acctNoSfx: undefined,
        acctNoSfxDesc: undefined,
        proplXol: undefined,
        riSipct: undefined,
        riLim: undefined,
        priority: undefined,
        terminated: false,
        cesNo: 0,
        cesYr: undefined,
        plaDate: undefined,
        theirPolNo: undefined,
        lastResAdv: undefined,
        theirClmNo: undefined,
        lastResAdvDate: undefined,
        createdBy: undefined,
        createdDate: undefined,
        modifiedBy: undefined,
        modifiedDate: undefined,
        recip: undefined,
        isNewRiHeader: true
      },
      pagination: {
        sortDesc: [true]
      },
      recipList: [
        { label: 'Yes', value: 'Y' },
        { label: 'No', value: 'N' },
        { label: 'Consortium', value: 'C' }
      ],
      totalItems: 0,
      menu: [],
      riAcctNoSfxItems: [],
      selectedRi: {}
    }
  },
  computed: {
    commonInfo() {
      return this.$store.state.claims.claimDetail.commonInfo
    }
  },
  watch: {
    // For pagination, we dont want to watch all the pagination property using deep (shown in vuetify eg)
    // This way the application will load multiple times at the start (when setting totalElements etc)
    'pagination': function (value) {
      this.fetchData()
    },
    load: function (value) {
      if (value) {
        this.fetchData()
      }
    }
  },
  methods: {
    async initRiData() {
      await Promise.all([this.$store.dispatch('riOutInit')])
      await this.$store.dispatch('riOutListingInit')
      await this.$store.dispatch('riAutoCessionInit')
    },
    doShowRiCo() {
      if (this.reinsurance.riType === 'T' || this.reinsurance.riType === 'W') {
        this.riTreatyDialog = true
        // this.riTreatyInit()
      } else if (this.reinsurance.riType === 'C' || this.reinsurance.riType === 'D' || this.reinsurance.riType === 'F') {
        this.riCoDialog = true
        this.riCoInit()
      }
    },
    doShowAcctNoSfx() {
      this.selectedRi.polNo = this.$store.state.claims.claimDetail.commonInfo.polNo
      if (this.reinsurance.riType === 'C') {
        this.riAcctNoSfxInit(6)
        this.riAcctNoSfxDialog = true
      } else if (this.reinsurance.riType === 'F') {
        this.riAcctNoSfxInit(5)
        this.riAcctNoSfxDialog = true
      }
    },
    setRicoInter(inter) {
      this.reinsurance.riCo = inter.inter
      this.reinsurance.riCoDesc = inter.inter + ' - ' + inter.name
      this.$validator.validate('riCo')
      this.riCoDialog = false
    },
    setRiCoTreaty(treaty) {
      this.reinsurance.riCo = treaty.ttyNo
      this.reinsurance.riCoDesc = treaty.ttyNo + ' - ' + treaty.ttyDesc
      this.$validator.validate('riCo')
      this.riTreatyDialog = false
    },
    setRiAcctNoSfx(riAcctNoSfx) {
      if (this.reinsurance.riType === 'C' || this.reinsurance.riType === 'F') {
        this.reinsurance.acctNoSfx = riAcctNoSfx.acctNoSfx
        this.reinsurance.acctNoSfxDesc = riAcctNoSfx.acctNoSfxDesc
        this.$validator.validate('acctNoSfx')
        this.riAcctNoSfxDialog = false
      }
    },
    riTypeChanged() {
      this.reinsurance.riCo = undefined
      this.reinsurance.riCoDesc = undefined
      this.reinsurance.acctNoSfx = undefined
      this.reinsurance.acctNoSfxDesc = undefined
      if (this.reinsurance.riType === 'X') {
        this.reinsurance.proplXol = 'X'
      } else {
        this.reinsurance.proplXol = 'P'
        if (this.reinsurance.riType === 'F' || this.reinsurance.riType === 'C') {
          this.disableSfx = false
        } else {
          this.disableSfx = true
        }
        if (this.reinsurance.riType === 'D') {
          this.reinsurance.riCo = 'STAT'
          this.reinsurance.riCoDesc = 'Statutory'
          this.disableRiCo = true
        } else {
          this.disableRiCo = false
        }
      }
    },
    doClearFilters() {
      // Iterate through each object field, key is name of the object field
      Object.keys(this.filters).forEach((key) => {
        this.filters[key] = undefined
      })
      this.fetchData(false)
    },
    doFilters() {
      this.resetMessages()
      this.$validator.validateAll().then((result) => {
        if (result) {
          // Reset to page 1
          this.pagination.page = 1
          this.fetchData(false)
        }
      })
    },
    async fetchData() {
      const apiUrl = this.$store.state.claims.claimDetail.menu.riHdrList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            clmNo: this.commonInfo.clmNo,
            includeAll: false
          }
          const result = await this.$http.get(filterQuery(expandURI(apiUrl, expand), this.filters, this.pagination.sortBy, this.pagination.sortDesc))
          const { data } = result.data
          this.totalItems = result.totalItem
          this.menu = extractMenu(result.data._links)
          if (data) {
            this.loading = false
            this.items = []
            data.map((riHdr) => {
              const convertRI = {
                clmNo: riHdr.clmNo,
                riType: riHdr.riType,
                riCo: riHdr.riCo,
                riCoDesc: riHdr.riCoDesc,
                acctNoSfx: riHdr.acctNoSfx,
                verCnt: riHdr.verCnt,
                proplXol: riHdr.proplXol,
                riTypeDesc: this.getItemValue(riHdr.riType, this.riTypeList).label,
                proplXolDesc: this.getItemValue(riHdr.proplXol, this.proplXolList).label,
                riSipct: formatDisplayNumber(riHdr.riSipct, 6),
                riLim: riHdr.riLim,
                priority: riHdr.priority,
                terminated: riHdr.terminated,
                cesNo: riHdr.cesNo,
                cesYr: riHdr.cesYr,
                recip: riHdr.recip,
                plaDate: riHdr.plaDate,
                lastResAdv: riHdr.lastResAdv,
                lastResAdvDate: riHdr.lastResAdvDate,
                theirPolNo: riHdr.theirPolNo,
                theirClmNo: riHdr.theirClmNo,
                createdBy: riHdr.createdBy,
                createdDate: riHdr.createdDate,
                modifiedBy: riHdr.modifiedBy,
                modifiedDate: riHdr.modifiedDate
              }
              this.items.push(convertRI)
            })
          } else {
            this.loading = false
            this.items = []
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.loading = false
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doCancel() {
      this.reinsuranceSection = false
    },
    doClose() {
      this.$emit('close')
    },
    addReinsurance() {
      this.mode = 'create'
      if (this.reinsuranceSection !== true) {
        this.reinsuranceSection = true
        this.reinsurance.verCnt = 0
        this.reinsurance.riType = 'T'
        this.riTypeChanged()
        this.reinsurance.riCo = undefined
        this.reinsurance.acctNoSfx = undefined
        this.reinsurance.proplXol = 'P'
        this.reinsurance.riSipct = formatDisplayNumber(0, 6)
        this.reinsurance.riLim = formatDisplayNumber(0, 2)
        this.reinsurance.priority = formatDisplayNumber(0, 2)
        this.reinsurance.cesNo = 0
        this.reinsurance.cesYr = new Date().getFullYear()
        this.reinsurance.terminated = false
        this.reinsurance.recip = 'N'
        this.reinsurance.lastResAdvDate = undefined
        this.reinsurance.lastResAdv = 0
        this.reinsurance.plaDate = undefined
        this.reinsurance.theirPolNo = undefined
        this.reinsurance.theirClmNo = undefined
        this.reinsurance.createdDate = undefined
        this.reinsurance.createdBy = undefined
        this.reinsurance.modifiedBy = undefined
        this.reinsurance.modifiedDate = undefined
        this.reinsurance.isNewRiHeader = true
        this.panel = []
        this.$nextTick(() => {
          this.$vuetify.goTo('#reinsuranceCard')
        })
      }
    },
    editReinsurance(data) {
      this.mode = 'review'
      const item = data.item
      this.reinsuranceSection = true
      this.reinsurance.verCnt = item.verCnt + 1
      this.reinsurance.riType = item.riType
      this.reinsurance.riCo = item.riCo
      this.reinsurance.acctNoSfx = item.acctNoSfx
      this.reinsurance.proplXol = item.proplXol
      this.reinsurance.riSipct = formatDisplayNumber(item.riSipct, 6)
      this.reinsurance.riLim = formatDisplayNumber(item.riLim, 2)
      this.reinsurance.priority = formatDisplayNumber(item.priority, 2)
      this.reinsurance.cesNo = item.cesNo
      this.reinsurance.cesYr = item.cesYr
      this.reinsurance.terminated = item.terminated
      this.reinsurance.recip = item.recip
      this.reinsurance.lastResAdv = item.lastResAdv
      this.reinsurance.lastResAdvDate = item.lastResAdvDate
      this.reinsurance.plaDate = item.plaDate
      this.reinsurance.theirPolNo = item.theirPolNo
      this.reinsurance.theirClmNo = item.theirClmNo
      this.reinsurance.createdDate = item.createdDate
      this.reinsurance.createdBy = item.createdBy
      this.reinsurance.modifiedBy = item.modifiedBy
      this.reinsurance.modifiedDate = item.modifiedDate
      this.reinsurance.isNewRiHeader = false
      this.panel = []
      this.$nextTick(() => {
        this.$vuetify.goTo('#reinsuranceCard')
      })
    },
    queryReinsurance(data) {
      this.mode = 'query'
      const item = data.item
      this.reinsuranceSection = true
      this.reinsurance.verCnt = item.verCnt
      this.reinsurance.riType = item.riType
      this.reinsurance.riCo = item.riCo
      this.reinsurance.riCoDesc = item.riCoDesc
      this.reinsurance.acctNoSfx = item.acctNoSfx
      this.reinsurance.proplXol = item.proplXol
      this.reinsurance.riSipct = formatDisplayNumber(item.riSipct, 6)
      this.reinsurance.riLim = formatDisplayNumber(item.riLim, 2)
      this.reinsurance.priority = formatDisplayNumber(item.priority, 2)
      this.reinsurance.cesNo = item.cesNo
      this.reinsurance.cesYr = item.cesYr
      this.reinsurance.terminated = item.terminated
      this.reinsurance.recip = item.recip
      this.reinsurance.lastResAdv = item.lastResAdv
      this.reinsurance.lastResAdvDate = item.lastResAdvDate
      this.reinsurance.plaDate = item.plaDate
      this.reinsurance.theirPolNo = item.theirPolNo
      this.reinsurance.theirClmNo = item.theirClmNo
      this.reinsurance.createdDate = item.createdDate
      this.reinsurance.createdBy = item.createdBy
      this.reinsurance.modifiedBy = item.modifiedBy
      this.reinsurance.modifiedDate = item.modifiedDate
      this.reinsurance.isNewRiHeader = false
      this.panel = []
      this.$nextTick(() => {
        this.$vuetify.goTo('#reinsuranceCard')
      })
    },
    doPromptRemove(item) {
      this.selectedRinsurance = item
      this.promptRemove = true
    },
    async doRemoveReinsurance() {
      const apiUrl = this.$store.state.claims.claimDetail.menu.riHdrList
      if (apiUrl) {
        try {
          const formatObj = {
            clmNo: this.selectedRinsurance.clmNo,
            verCnt: this.selectedRinsurance.verCnt,
            riType: this.selectedRinsurance.riType,
            riCo: this.selectedRinsurance.riCo,
            acctNoSfx: this.selectedRinsurance.acctNoSfx
          }
          const result = this.$http.post(apiUrl, formatObj)
          const { data } = result.data
          if (result.data) {
            this.notify(data)
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
      }
    },
    async doSave() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.saveRecord().then((success) => {
            // this.commonInfo.hasRIorResAdj = true
            this.fetchData()
          })
        } else {
          this.promptFieldCheck()
        }
      })
    },
    async saveRecord() {
      const apiUrl = this.menu.riHeaderSave
      if (apiUrl) {
        const formatObject = {
          ...this.reinsurance,
          riSipct: removeFormatNumber(this.reinsurance.riSipct),
          riLim: removeFormatNumber(this.reinsurance.riLim),
          priority: removeFormatNumber(this.reinsurance.priority),
          clmNo: this.commonInfo.clmNo
        }
        this.$http
          .post(apiUrl, formatObject)
          .then((result) => {
            if (result.data) {
              let obj = { hasRIOrResAdj: true }
              this.$store.commit(CLAIMS_HASRIORRESADJ, obj)
              const data = result.data
              this.notify(data)
              this.reinsuranceSection = false
            }
            return true
          })
          .catch((err) => {
            const { data } = err.response
            if (data) {
              let message = data.messages[0].message
              this.$toast.error(message)
              this.message(data)
              this.fieldMessage(data)
              return false
            }
          })
      } else {
        this.$toast.error('The request failed because it is trying to execute an invalid API url.')
        return false
      }
    },
    formatDisplayDateTime(value) {
      return formatDisplayDateTime(value)
    }
  },
  created() {
    const billCoins = this.commonInfo.billCoins
    this.$validator.extend('validRiType', {
      getMessage(field, args) {
        return `This ${field} is not valid for this claim.`
      },
      validate(value, args) {
        if (value) {
          if (value === 'C' && billCoins !== 'Y') {
            return false
          }
        }
        return true
      }
    })
  },
  mounted() {
    this.initRiData()
    this.fetchData()
  },
  mixins: [MessageMixin, listMixin, ClaimCommonMixin, riAjaxMixin, riListMixin]
}
</script>

<style>
</style>
